import { RandomString } from "./randomString";

export function createPurchaseDataPoint(
    purchase,
    userData,
    mcData
) {
    if (!purchase || !userData || !mcData) {
        // console.log(purchase);
        // console.log(userData);
        // console.log(mcData);
        return;
    }
    const ts = new Date(purchase.add_date).getTime();
    const usercode = userData.cst_key.substring(0,8);
    let obj = {
        'cst_key': userData.cst_key,
        'fName': userData.fName,
        'id': `${ts}-${usercode}-${RandomString(8)}`,
        'lName': userData.lName,
        'mc_key': mcData.mc_key,
        'progressId': `${mcData.mc_key}_${userData.cst_key}`,
        'ts': ts,
        'type': 'purchase-completed'
    }
    return obj;
}